import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getSmartListCount = createAsyncThunk("leadList/getSmartListCount", async (data, thunkAPI) => {
  try {
    const resp = await axios.put(`${process.env.REACT_APP_BASE_URL}api/leads/people/smartlist-count`,data, {
      headers: {
        "Content-Type": "application/json",
      }
    });
    return resp.data.updatedSmartlistCount;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});

export const getLeadsSmartList = createAsyncThunk("leadList/getLeadsSmartList", async (data, thunkAPI) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/smartlists?type=lead`, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { all: "true" },
    });
     if(resp.data.smartlists?.length){
       thunkAPI.dispatch(getSmartListCount({smartListIds:resp.data.smartlists?.map(item=>item.id)}))
     }
    return resp.data.smartlists;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});

